import React, { useState } from "react";
import wbsHeaderLogo from "../../img/wbs-group-logo.png";
import { Container, Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux'
import { useMsal } from "@azure/msal-react";
import { setFirstName, setLastName, setStartDate, setEndDate, setUuidOffer, setLoading, setLearningData, setLoadLearningData } from '../../store/features/participant'
import { setIntervals, setToFinish, setLoadingIntervalls } from '../../store/features/intervals'
import { setServerDate } from '../../store/features/serverDate'
import { setReasons, setTimes } from '../../store/features/absences'
import { setSkills, setMediums } from '../../store/features/learning'
import { setDateOptions, setSelectedDay, setTimeOptions, setFromTime, setTillTime, setWhatCanYouNow, setSelectedCategorysArray } from '../../store/features/learning'
import { setActive, setSession, setError, setErrorCode, setNoOfferTrigger } from '../../store/features/session'

import { CLearningData } from '../../constants/participantLearningData'

const Navigation = (): JSX.Element => {
  const dispatch = useDispatch()
  const { instance } = useMsal()

  const [NavExpanded, setNavExpanded] = useState(false);

  const handleNavExpanded = (expanded: any) => setNavExpanded(expanded);

  const doLogoutUser = () => {
    destroyStore();
    instance.logout()
  }

  const destroyStore = () => {
    dispatch(setFirstName(""));
    dispatch(setLastName(""));
    dispatch(setStartDate(""));
    dispatch(setEndDate(""));
    dispatch(setUuidOffer(""));
    dispatch(setLoading(true));
    dispatch(setLearningData(CLearningData));
    dispatch(setLoadLearningData(true));
    dispatch(setIntervals([]));
    dispatch(setToFinish({ value: "", label: "" }));
    dispatch(setServerDate(""));
    dispatch(setReasons([]));
    dispatch(setTimes([]));
    dispatch(setSkills([]));
    dispatch(setMediums([]));
    dispatch(setDateOptions([]));
    dispatch(setTimeOptions([]));
    dispatch(setSelectedDay({ value: "", label: "" }));
    dispatch(setFromTime({ value: "Anfang", label: "" }));
    dispatch(setTillTime({ value: "Ende", label: "" }));
    dispatch(setWhatCanYouNow(""));
    dispatch(setSelectedCategorysArray([]));
    dispatch(setLoadingIntervalls(true));
    dispatch(setActive(false))
    dispatch(setSession(''))
    dispatch(setError(false))
    dispatch(setErrorCode(''))
    dispatch(setNoOfferTrigger(false))
  }

  return (
    <div>
      <Navbar onToggle={handleNavExpanded} expanded={NavExpanded} className="lzk-primary-navbar shadow-sm" bg="light" expand="xl" fixed="top">
        <Container>
          <Navbar.Brand>
            <Link to="/">
              <img className="lzk-header-logo" alt="lzk-header-logo" src={wbsHeaderLogo}></img>
            </Link>
          </Navbar.Brand>

          <Nav className="ml-auto nav-link-container">
            <Link onClick={() => doLogoutUser()} className="top-nav-link" to="/">
              <i className="fal fa-sign-out nav-icons"></i>logout
            </Link>
          </Nav>

        </Container>
      </Navbar>
    </div>
  );
};

export default Navigation;
